import { createContext, useRef, useState } from "react";

const AppContext = createContext();

const ContextProvider = ({ children }) => {
  const [modalShow, setModalShow] = useState(false);
  const [chatbotShow, setChatbotShow] = useState(false);
  const [activeRoute, setActiveRoute] = useState("/");
  const [activeSection, setActiveSection] = useState("");

  const homeRef = useRef(null);
  const coursesRef = useRef(null);
  const successStoriesRef = useRef(null);
  const trustedByStudents = useRef(null);
  return (
    <AppContext.Provider
      value={{
        modalShow,
        setModalShow,
        homeRef,
        coursesRef,
        successStoriesRef,
        trustedByStudents,
        activeRoute,
        setActiveRoute,
        activeSection,
        setActiveSection,
        chatbotShow,
        setChatbotShow,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, ContextProvider };
